import React, { useCallback } from "react";
import { PageProps } from "gatsby";
import { SignupForOffersPageQuery } from "types/graphql-types";
import PageBuilderOpeningText from "components/PageBuilder/PageBuilderOpeningText";
import {
  SectionContainer,
  InlineFormContainer
} from "@silversea-ssc/ui-components-react";
import OpenGraph from "components/SEO/OpenGraph";
import DefaultSubscribeForm, {
  CruiseSuiteFormProps
} from "components/DefaultSubscribeForm/DefaultSubscribeForm";
import { isSSR } from "src/utils/ssr";

const SignupForOffersTemplate: React.FC<
  PageProps<SignupForOffersPageQuery> & {
    cruiseSuiteForm?: CruiseSuiteFormProps;
  }
> = (props) => {
  const { data } = props;
  const { thankYouPageURL } = data;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const page = data.page!;

  const onSubmitSuccess = useCallback(() => {
    if (!isSSR() && thankYouPageURL?.path) {
      window.location.href = thankYouPageURL?.path;
    }
  }, [thankYouPageURL?.path]);

  return (
    <React.Fragment>
      <OpenGraph
        openGraph={page?.metadata?.openGraph}
        excludeFromSitemap={true}
      />

      <SectionContainer
        spacingTop="regular"
        spacingBottom="compact"
        backgroundColor="white"
      >
        <PageBuilderOpeningText {...page.heading} />
      </SectionContainer>
      <InlineFormContainer>
        <DefaultSubscribeForm
          formName="SignupForOffersForm"
          onSubmitSuccess={onSubmitSuccess}
          requestSource="SFO"
          requestType="SFO"
          askImNotTraveAgent={false}
          askWorkWithAgent={true}
          askPhone={false}
          askDescription={false}
          dataContentName="sfo_form"
          cruiseSuiteInfo={props.cruiseSuiteForm}
        />
      </InlineFormContainer>
    </React.Fragment>
  );
};

export default SignupForOffersTemplate;
